<template>
  <v-card class="profile-customer-review t-profile-customer-review">
    <v-card-title class="profile-customer-review__heading">{{ title }}</v-card-title>

    <scrollable-container>
      <data-row>
        <v-flex>
          <one-data-column>
            <data-label slot="label">EMI profile</data-label>
            <div class="t-profile font-weight-medium">{{ profile.name }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Master account</data-label>
            <div class="t-master-account">{{ masterAccountInfo }}</div>
          </one-data-column>

          <one-data-column v-if="isCreateMode">
            <data-label slot="label">Channel</data-label>
            <div class="t-channel">{{ data.channel | optionName(channelOptions) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Type</data-label>
            <div class="t-type">{{ data.type | optionName(typeOptions) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Status</data-label>
            <div class="t-status">{{ data.status | optionName(statusOptions) }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Customer info</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">{{ getFieldLabel('name') }}</data-label>
            <div class="t-name">{{ data.name }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">{{ getFieldLabel('regNumber') }}</data-label>
            <div class="t-reg-number">{{ getOptionalValue(data.regNumber) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">{{ getFieldLabel('registrationDate') }}</data-label>
            <div class="t-reg-date">{{ getOptionalDate(data.registrationDate) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">{{ getFieldLabel('citizenship') }}</data-label>
            <div class="t-citizenship">{{ getCountryName(data.citizenship) }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Address</data-label>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Country</data-label>
            <div class="t-country">{{ getCountryName(data.country) }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Street</data-label>
            <div class="t-street">{{ data.street }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">City</data-label>
            <div class="t-city">{{ data.city }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Postcode</data-label>
            <div class="t-zip">{{ getOptionalValue(data.zip) }}</div>
          </one-data-column>

          <one-data-column :label-props="{ style: 'display: none;' }">
            <data-divider />
          </one-data-column>

        </v-flex>
      </data-row>
    </scrollable-container>

    <v-divider class="grey lighten-3" />
    <v-card-actions class="profile-customer-review__actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        flat="flat"
        v-bind="confirmButtonProps"
        @click="$emit('confirm')"
      >{{ confirmButtonText }}</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        flat="flat"
        v-bind="cancelButtonProps"
        @click="$emit('cancel')"
      >cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Models
  import Payment from '@/models/Payment'
  import Profile from '@/models/AccountProfile'
  import ProfileCustomer from '@/models/ProfileCustomer'

  // Mixins
  import countries from '@/mixins/countries'
  import profileCustomerMixin from '@/mixins/profileCustomer'

  // Components
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import DataDivider from '@/components/ui/Data/DataDivider'

  export default {
    name: 'ProfileCustomerReview',
    components: {
      ScrollableContainer,
      DataRow,
      OneDataColumn,
      DataLabel,
      DataDivider
    },
    mixins: [countries, profileCustomerMixin],
    props: {
      profile: {
        required: true,
        type: Profile
      },
      data: {
        required: true,
        type: Object
      },
      mode: {
        type: String,
        default: 'create'
      },
      title: {
        type: String,
        default: 'Please, check all information again and confirm'
      },
      confirmButtonText: {
        type: String,
        default: 'Confirm'
      },
      confirmButtonProps: {
        type: Object,
        default: undefined
      },
      cancelButtonProps: {
        type: Object,
        default: undefined
      }
    },
    computed: {
      channelOptions () {
        return Payment.channelOptions
      },
      customerType () {
        return this.data.type
      },
      isCreateMode () {
        return this.mode === 'create'
      },
      masterAccountId () {
        return this.data.accountId
      },
      typeOptions () {
        return Profile.typeOptions
      },
      statusOptions () {
        return ProfileCustomer.statusOptions
      }
    }
  }
</script>

<style lang="scss">
  .profile-customer-review {
    font-size: 16px;
    font-weight: 400;

    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
    }

    &__actions {
      padding: 14px 14px;
    }
  }
</style>
